import React from 'react';
import {Form, Formik} from "formik";
import * as Yup from "yup";
import {Form as FormLayout} from "react-bootstrap";
import TextInput from "../../../../../Common/components/text-input";
import {formatFormTitle, FormikMultiFormSync} from "../../../../../../util/Helpers";
import SelectInput from "../../../../../Common/components/select-input";
import {INVESTMENT_OBJECTIVE_OPTIONS} from "../../../../data/InvestmentObjectiveOptions";
import {INVESTMENT_EXPERIENCE_OPTIONS} from "../../../../data/InvestmentExperienceOptions";
import {RISK_TOLERANCE_OPTIONS} from "../../../../data/RiskToleranceOptions";

function InvestmentProfile(
    {
        dataKey,
        title,
        isEditable,
        initialValues: {
            investmentData = {}
        }
    }
) {
    const validationSchema = Yup.object({
        annualIncome: Yup.number().required('Required'),
        investmentExperience: Yup.string().required('Required'),
        investmentObjectives: Yup.string().required('Required'),
        networthLiquid: Yup.number().required('Required'),
        networthTotal: Yup.number().required('Required'),
        riskTolerance: Yup.string().required('Required'),
        taxRate: Yup.number(),
    })

    const compiledInitialValues = {
        annualIncome: "",
        investmentExperience: "",
        investmentObjectives: "",
        networthLiquid: "",
        networthTotal: "",
        riskTolerance: "",
        taxRate: "",
        ...investmentData
    }

    return (
        <div>
            <Formik
                validationSchema={validationSchema}
                initialValues={compiledInitialValues}
                validateOnMount={true}
                enableReinitialize={true}
            >
                {({isValid}) =>
                    <Form>
                        <fieldset disabled={!isEditable}>
                            {formatFormTitle({title, isValid})}
                            <FormLayout.Row>
                                <TextInput
                                    label="Approximate annual income (USD)*"
                                    name="annualIncome"
                                    type="number"
                                />
                            </FormLayout.Row>
                            <FormLayout.Row>
                                <TextInput
                                    label="Liquid net worth (USD)*"
                                    name="networthLiquid"
                                    type="number"
                                />
                                <TextInput
                                    label="Total net worth (USD)*"
                                    name="networthTotal"
                                    type="number"
                                />
                                <TextInput
                                    label="User's tax rate"
                                    name="taxRate"
                                    type="number"
                                />
                            </FormLayout.Row>
                            <FormLayout.Row>
                                <SelectInput
                                    label="Investment objectives*"
                                    name="investmentObjectives"
                                    options={INVESTMENT_OBJECTIVE_OPTIONS}
                                />
                                <SelectInput
                                    label="Investment experience*"
                                    name="investmentExperience"
                                    options={INVESTMENT_EXPERIENCE_OPTIONS}
                                />
                                <SelectInput
                                    label="Risk tolerance*"
                                    name="riskTolerance"
                                    options={RISK_TOLERANCE_OPTIONS}
                                />
                            </FormLayout.Row>
                            <FormikMultiFormSync name={dataKey}/>
                        </fieldset>
                    </Form>
                }
            </Formik>
        </div>
    );
}

export default InvestmentProfile;